<template>
  <div>
    <div class="fixed top-0 w-full pt-[8px] bg-white">
      <NavBar />
    </div>
    <div>
      <div class="w-[500px] h-auto px-10 top-[75px] mt-[25px] sm:fixed">
        <div class="w-1/2">
          <v-expansion-panels>
            <ExpansionPanelTitle title="Move-in Turnover" />
            <v-expansion-panel v-for="(item, i) in parent" :key="i">
              <v-expansion-panel-header>
                {{ item.title }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-for="(item, j) in item.child" :key="j">
                  <button
                    v-scroll-to="item.scroll_to"
                    class="
                      w-full
                      hover:text-red-900 hover:bg-gray-200
                      p-2
                      flex
                    "
                  >
                    {{ item.title }}
                  </button>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <!-- <a href="#" v-scroll-to="'#class1'">class 1</a> -->
        <!-- <v-btn-toggle class="flex-col">
          <div class="bg-red-200" v-for="(item, i) in items" :key="i">
            <v-btn
              class="w-full"
              v-scroll-to="item.scroll_to"
              small
              elevation=""
              color=""
            >
              {{ item.title }}
            </v-btn>
          </div>
        </v-btn-toggle> -->
      </div>
      <div class="sm:ml-[250px] sm:px-10 mt-[75px] min-w-[750px]">
        <MoveinTurnoverRequirements
          class="class1 pt-[25px]"
          :hTitle="'Move-in Turnover Requirements'"
        />
        <DocumentsRequired class="class2 pt-[25px]" :hTitle="'Documents Required'" />
        <PaymentsRequired class="class3 pt-[25px]" :hTitle="'Payments Required'" />
      </div>
    </div>
  </div>
</template>

<script>
import ExpansionPanelTitle from "../../../components/ExpansionPanelTitle.vue";
import MoveinTurnoverRequirements from "./Requirements.vue";
import DocumentsRequired from "./Documents.vue";
import PaymentsRequired from "./Payments.vue";
import NavBar from "../../../../../common/NavBar-Fixed.vue";

export default {
  components: {
    MoveinTurnoverRequirements,
    DocumentsRequired,
    PaymentsRequired,
    NavBar,
    ExpansionPanelTitle,
  },
  data() {
    return {
      show: false,
      parent: [
        {
          title: "Move-in Turnover Requirements",
          id: 1,
          child: [
            {
              title: "Move-in / Turnover",
              scroll_to: ".class1",
            },
            {
              title: "Documents Required",
              scroll_to: ".class2",
            },
            {
              title: "Payments Required",
              scroll_to: ".class3",
            },
          ],
        },
      ],
    };
  },
};
</script>
